import { render, staticRenderFns } from "./InstagramPopup.vue?vue&type=template&id=798ab1fb&"
import script from "./InstagramPopup.vue?vue&type=script&lang=js&"
export * from "./InstagramPopup.vue?vue&type=script&lang=js&"
import style0 from "./InstagramPopup.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DynamicImg: require('/opt/build/repo/storefront/components/legacy/global/dynamic-img.vue').default,BaseCopy: require('/opt/build/repo/storefront/components/atoms/Text/BaseCopy.vue').default,LineLink: require('/opt/build/repo/storefront/components/atoms/Link/LineLink.vue').default})
